import { blue, purple, red, orange, yellow, green, cyan, pink, teal, indigo } from '@mui/material/colors';

export const colors = {
    blue,
    purple,
    red,
    orange,
    yellow,
    green,
    cyan,
    pink
};

/**
 * The palette users can pick from when creating/editing a label.
 * Yellow uses a darker shade so the chip text stays readable on white.
 */
export const labelColorOptions = [
    blue[500],
    purple[500],
    red[500],
    orange[500],
    yellow[800],
    green[500],
    cyan[500],
    pink[500],
    teal[500],
    indigo[500],
];
